import { render, staticRenderFns } from "./MeusBoletos.vue?vue&type=template&id=6d17448a&scoped=true"
import script from "./MeusBoletos.vue?vue&type=script&lang=js"
export * from "./MeusBoletos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17448a",
  null
  
)

export default component.exports